var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoach(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-46 -46 552.00 552.00",
    xmlSpace: "preserve",
    width: "256px",
    height: "256px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -46,
    y: -46,
    width: 552,
    height: 552,
    rx: 0,
    fill: "#ffffff",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    d: "M187.433,270.696c-10.714,4.946-20.899,10.838-30.433,17.592V445h97V334.319 C220.917,328.679,194.521,303.488,187.433,270.696z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    d: "M268.065,305.528c26.536,0,48.525-19.752,52.029-45.363c-16.547-4.625-33.996-7.101-52.029-7.101 c-18.032,0-35.482,2.476-52.028,7.101C219.541,285.776,241.53,305.528,268.065,305.528z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    d: "M348.698,270.696c-6.955,32.172-32.491,57.038-64.698,63.292V445h176 C460,367.386,414.414,301.031,348.698,270.696z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_71_",
    d: "M269,119v30H168.422c12.868,42.846,52.607,74.064,99.643,74.064c57.455,0,104.032-46.577,104.032-104.032 S325.52,15,268.065,15c-47.013,0-86.735,31.188-99.624,74H108v30H269z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_85_",
    x: 30,
    y: 253,
    width: 67,
    height: 30
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_86_",
    points: "127,283 97,283 97,313 30,313 30,283 0,283 0,445 127,445 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoach);
export default __webpack_public_path__ + "static/media/coach.d36a747b0c632edf9f69886a7196ff0c.svg";
export { ForwardRef as ReactComponent };